<ng-container *ngIf="!isError; else HTTPError">
  <ion-grid>
    <ion-row *ngIf="reportTaskServ.reportTask.description">
      <ion-col>
        <h3 class="report-task-detail__subheader">
          {{ "REPORT_TASK.DESCRIPTION" | translate }}
        </h3>
        <div>
          {{ reportTaskServ.reportTask.description }}
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col [attr.size]="mobileView ? '6' : '12'">
        <h3 class="report-task-detail__subheader">
          {{ "REPORT_TASK.TASK_FROM" | translate }}
        </h3>
        <app-user-with-avatar
          [user]="reportTaskServ.reportTask.assignmentBy"
          [grayBackground]="true"
        ></app-user-with-avatar>
      </ion-col>
      <ion-col [attr.size]="mobileView ? '6' : '12'">
        <h3 class="report-task-detail__subheader">
          {{ "REPORT_TASK.TASK_TO" | translate }}
        </h3>
        <app-user-with-avatar
          [user]="reportTaskServ.reportTask.performedBy"
          [selectable]="true"
          (closed)="modalToggle(false)"
          (click)="modalToggle(true)"
          (userChanged)="userChanged($event)"
          [grayBackground]="true"
        ></app-user-with-avatar>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <h3 class="report-task-detail__subheader">
          {{ "REPORT_TASK.STATUS" | translate }}
        </h3>
        <app-select-buttons
          *ngIf="showStatusButtons"
          [keyValueList]="dictionaryService.reportTaskStatusValues"
          [selectedValue]="reportTaskServ.reportTask.status"
          [confirmChange]="true"
          [disabled]="disableEditing()"
          [outline]="true"
          icon="circle"
          [customMessage]="
            translateService.instant('REPORT.STATUS_CONFIRM_MESSAGE')
          "
          (selectedChange)="selectedStatusChange($event)"
        >
        </app-select-buttons>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="report-task-detail__separator"></div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-comment
          [userPerformedBy]="reportTaskServ.reportTask.idUserPerformedBy"
          [id]="reportTaskId"
          [tableName]="reportTaskServ.tableName"
          [refreshCommentsOnInit]="false"
          [comments]="reportTaskServ.reportTask.comments"
          mode="comment"
          deletePermission="report-task.comments.delete"
        ></app-comment>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>

<ng-template #HTTPError>
  <app-api-not-found
    name="REPORT_TASK.TASK"
    returnText="REPORT_TASK.RETURN_TO_REPORT_TASK"
    link="app/report-task"
    [status]="errorStatus"
  >
  </app-api-not-found>
</ng-template>
